import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiDiagramsList, apiDiagramsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/diagrams/getData', async datas => {
    const { data } = await apiDiagramsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/diagrams/getView', async id => {
    if (!id) return viewData
    const { data } = await apiDiagramsView(id)
    data.image = ''
    return data
})

const viewData = {
    name: '',
    type: '',
    image: '',
}

export const diagramsSlice = createSlice({
    name: 'admin/diagrams',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            type: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setType: (state, { payload }) => {
            state.table.page = 1
            state.table.type = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setType } = diagramsSlice.actions

export default diagramsSlice.reducer
